import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { getRecent } from "@/lib/recentlyViewed";
import ProductCard from "@/components/ProductCard";

export default function RecentlyViewed({ exclude, title = "Vizualizate recent", limit = 4 }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const slugs = getRecent().filter((s) => s !== exclude).slice(0, limit);
    if (!slugs.length) {
      setItems([]);
      return;
    }
    api.get(`/products/by-slugs?slugs=${slugs.join(",")}`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [exclude, limit]);

  if (items.length === 0) return null;

  return (
    <div className="mt-28" data-testid="recently-viewed">
      <h2 className="font-display text-4xl md:text-5xl tracking-tight mb-12">{title}</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
        {items.map((p, i) => (
          <ProductCard key={p.slug} product={p} index={i} />
        ))}
      </div>
    </div>
  );
}
